import axios from "axios";
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_B2B_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getLocationInfoByAddress = async (address: any) => {
    const URL = `/getLocationInfoByAddress?address=${address}`
    try {
        var config = {
            method: 'get',
            url: URL,
        };
        const response = await axiosInstance(config)
        return response?.data?.data

    } catch (e) {
        return {
            status: 400,
            err: e,
            data: ""
        }
    }
}